import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavigationArrowLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.4922 2.78157C16.0997 2.35577 17.5885 3.83079 17.1753 5.4427L17.1273 5.60465L13.7167 15.7926C13.0919 17.6582 10.5485 17.8049 9.68349 16.106L9.60536 15.9351L8.11692 12.3364H8.1161C8.01943 12.1022 7.83222 11.9168 7.59771 11.8221V11.8213L4.12847 10.4167C2.24719 9.65437 2.31717 6.9664 4.23752 6.30533L14.3303 2.8304H14.3311L14.4922 2.78157ZM14.8755 3.97542L14.7372 4.01285L4.64442 7.48697C3.81762 7.77149 3.78626 8.92984 4.59722 9.25862L8.06646 10.6624H8.06565C8.61152 10.8828 9.0468 11.3143 9.2717 11.8587L10.7601 15.4573L10.7935 15.5306C11.1661 16.2628 12.2616 16.1997 12.531 15.3963L15.9424 5.20751L15.9782 5.06917C16.0944 4.4254 15.5184 3.85406 14.8755 3.97542Z",
		fill: "black",
		fillOpacity: .64
	})
});
export default SvgNavigationArrowLine;
